module.exports = __webpack_public_path__ + "static/25gde-f7cb60cd0d3d0c193d2efa94ce572a54.gif";